import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { resumeIndividualSavings } from "api/individual-user-management";
import { ReactComponent as PlayIcon } from "assets/icons/play-rounded-green.svg";
import { useIndividuals } from "contexts/individuals-context";
import { transactionLimitModalHeaderCss } from "features/individuals/individual-details/styles";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { DEFAULT_PAGINATION_DATA } from "ui/pagination";
import { Heading3, Paragraph3 } from "ui/typography";

import { IResumeSavingsModalProps } from "./types";

export const ResumeSavingsModal = (props: IResumeSavingsModalProps) => {
  const {
    isOpen,
    setIsOpen,
    handleToggleResumeSavingsModal,
    id,
    type,
    walletId,
  } = props;

  const [isResuming, setIsResuming] = useState(false);

  const { handleGetIndividualSavings } = useIndividuals();

  const handleResumeSavings = async () => {
    // if (!individualDetails) return;
    setIsResuming(true);
    try {
      const { error, message } = await resumeIndividualSavings({
        id: id || "",
        plan: type || "flex",
      });
      if (error) {
        customErrorToast({
          message,
        });
        // setIsOpen(false);
        handleToggleResumeSavingsModal();
      } else {
        customSuccessToast({
          message: "Savings Resumed Successfully",
        });
        // await handleGetIndividualDetails(individualDetails?.id);
        await handleGetIndividualSavings({
          walletId: +walletId,
          page: DEFAULT_PAGINATION_DATA.page,
          limit: DEFAULT_PAGINATION_DATA.page,
        });
        handleToggleResumeSavingsModal();
        // setIsOpen(false);
      }
    } catch (error) {
      console.error("Error: ", error);
      // setIsOpen(false);
      handleToggleResumeSavingsModal();
    }
    setIsResuming(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        // height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="others"
          HeaderIcon={<PlayIcon />}
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            Resume This Goal Savings
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
        </Box>
      </Box>
      <Box
        css={{
          //   height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleToggleResumeSavingsModal}
          disabled={isResuming}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          border="1px solid #00535C"
          className="w-[170px]"
          onClick={handleResumeSavings}
          disabled={isResuming}
          loading={isResuming}
          loadingText="Resuming..."
        >
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};
